import { useQuery } from "@tanstack/react-query";

import apiDal from "../config/apiDal";
import { Place } from "../types";

type GetPlacesParams = {
	locale?: string;
};

const fetchPlaces = async (locale: string = "en-us"): Promise<Place[]> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getLossPlace",
		bind: {
			locale: locale.toLowerCase(),
		},
	});

	return response.data.result;
};

export const useGetPlaces = ({ locale }: GetPlacesParams) => {
	return useQuery<Place[]>({
		queryKey: ["getLossPlace", locale],
		queryFn: () => fetchPlaces(locale),
		select: (data) => data,
	});
};
